export default __webpack_public_path__ + "static/media/muazu.f328f8cd.jpg";